import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
/**
 * Servicio que gestiona el spiner loading
 */
@Injectable()
export class SpinnerAlertService {

  /**
   * Subscripcion para desplegar spinner
   */
  private subject: Subject<any>;

  /**
   * Inicializa la subscripcion
   */
  constructor() {
    this.subject = new Subject<any>();
  }

  /**
   * Muestra el spinner
   */
  show(): void {
    this.subject.next(true);
  }

  /**
   * Oculta el spinner
   */
  hide(): void {
    this.subject.next(false);
  }

  /**
   * Presenta el spinner
   */
  showAlert(): Observable<any> {
    return this.subject.asObservable();
  }

}
